import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class DisplayScanApiService {
	private readonly apiURL = environment.apiUrl;
	private readonly httpClient = inject(HttpClient);

	getScan(scanId: string): Observable<Blob> {
		return this.httpClient.get<Blob>(`${this.apiURL}/gbox/get_scan/${scanId}/`, {
			// eslint-disable-next-line  @typescript-eslint/no-explicit-any
			responseType: 'blob' as any,
		});
	}
}
